
import api from '@/api';

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  async fetchListForEquipment(store, equipmentId) {
    try {
      const { data: equipmentNotes } = await api.get(`/equipment-notes/equipment/${equipmentId}`);

      return equipmentNotes;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async addForEquipment(store, { equipmentId, note }) {
    try {
      const { data: equipmentNote } = await api.post(`/equipment-notes`, {
        Equipment_id: equipmentId,
        note,
      });

      return equipmentNote;
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
